import { Box, Stack } from "@mui/material"
import EmptyAdvertisement from "./EmptyAdvertisement"
import { AdvertisementType } from "@/common/types"
import Advertisement from "./Advertisement"
import useListAdvertisementImages from "@/hooks/api/advertisements/ustListAdvertisementImages"

export default function LeftAdvertisements() {
  const { data: advertisementImages, isLoading: advertisementsLoading } =
    useListAdvertisementImages()

  if (advertisementsLoading) {
    return <>...loading</>
  }

  const leftLargeImage: AdvertisementType = advertisementImages.data.filter(
    (image: AdvertisementType) => image.slot_name === "left_large"
  )[0]
  const leftSmallImage: AdvertisementType = advertisementImages.data.filter(
    (image: AdvertisementType) => image.slot_name === "left_small"
  )[0]
  return (
    <Stack sx={{ maxHeight: "700px", minHeight: "700px", minWidth: "218px" }}>
      {advertisementImages.data.filter(
        (image: AdvertisementType) => image.slot_name === "left_small"
      ).length ? (
        <Advertisement
          hrefLink={leftSmallImage.action_link}
          imageUrl={leftSmallImage.small_image}
          companyName={leftSmallImage.company_name}
          advertisementId={leftSmallImage.advertisement_id}
          aspectRatio="short"
          additionalStyling={{
            minHeight: "280px",
            maxHeight: "280px",
            borderTopRightRadius: "8px",
            borderEndEndRadius: "8px",
            maxWidth: "218px",
          }}
        />
      ) : (
        <EmptyAdvertisement
          additionalStyling={{
            minHeight: "280px",
            maxHeight: "280px",
            borderTopRightRadius: "8px",
            borderEndEndRadius: "8px",
            minWidth: "218px",
            maxWidth: "218px",
          }}
        />
      )}
      <Box sx={{ height: "5%" }}></Box>
      {advertisementImages.data.filter(
        (image: AdvertisementType) => image.slot_name === "left_large"
      ).length ? (
        <Advertisement
          hrefLink={leftLargeImage.action_link}
          imageUrl={leftLargeImage.large_image}
          companyName={leftLargeImage.company_name}
          advertisementId={leftLargeImage.advertisement_id}
          aspectRatio="tall"
          additionalStyling={{
            minHeight: "360px",
            maxHeight: "360px",
            borderTopRightRadius: "8px",
            borderEndEndRadius: "8px",
            maxWidth: "218px",
          }}
        />
      ) : (
        <EmptyAdvertisement
          additionalStyling={{
            minHeight: "360px",
            maxHeight: "360px",
            borderTopRightRadius: "8px",
            borderEndEndRadius: "8px",
            maxWidth: "218px",
          }}
        />
      )}
    </Stack>
  )
}
